import MapElement from "./MapElement";
import DXFLayer from './MapDXFLayer';
import LayerGroup from "ol/layer/Group";
import FeatureDrawer from "../helpers/FeatureDrawer";
import FeatureStyle from '../helpers/FeatureStyles';
import LineString from 'ol/geom/LineString';
import Feature from 'ol/Feature';

export default class MapDXF extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent);

        this.layer = null
        this.drawStyle = null;
    }

    initializeSelect() {
        super.initializeSelect()
        this.selectInteraction.style_ = (ft, res) => { return FeatureStyle.customLineStyle(ft, res, this.mapModel.dark, true); };
    }

    drawLayer(dxf, projection, drawStyle, callback = null) {
        this.drawStyle = drawStyle;

        var errorFeatureDrawer = false;
        if (this.selectInteraction) {
            switch (this.drawStyle) {
                case "roadprofiler":
                    this.selectInteraction.style_ = (ft, res) => { return FeatureStyle.customProfilerStyle(ft, res, this.mapModel.dark, true); };
                    break;
                case "vector":
                    this.selectInteraction.style_ = (ft, res) => { return FeatureStyle.curstomVectorStyle(ft, res, this.mapModel.dark, true); };
                    break;
                case "spraypoints":
                    this.selectInteraction.style_ = (ft, res) => { return FeatureStyle.customSprayPointsStyle(ft, res, this.mapModel.dark, true); }
                    break;
                default:
                    this.selectInteraction.style_ = (ft, res) => { return FeatureStyle.customLineStyle(ft, res, this.mapModel.dark, true); };
                    break;
            }
        }



        var featureDrawer = new FeatureDrawer(projection, this.mapModel.projection);

        var childSettings = {
            clickmethod: this.mapElementSettings.clickmethod,
            interactable: true,
            group: true,
            defaultOn: this.mapElementSettings.defaultOn,
            actions: this.mapElementSettings.actions
        }

        var sourcesSteeringModelLayer = {};

        var invalidEntities = []
        var i = 0;
        console.log(dxf)

        dxf.parsed.entities.forEach(entity => {
            var tryToDraw = !('paperSpace' in entity && entity.paperSpace == 1)

            if (tryToDraw) { // if (!('inPaperSpace' in entity && entity.inPaperSpace)) { // this might not work anymore
                var feature = null;
                try {
                    feature = featureDrawer.drawFeature(entity, i);
                } catch (error) {
                    feature = null
                    errorFeatureDrawer = true;
                    invalidEntities.push(entity);
                    // todo send error back in callback function
                    // er ging iets fout bij het tekenen van features, tekening bevat features die niet getekend kunnen worden
                }

                if (feature !== null) {
                    if (!(entity.layer in sourcesSteeringModelLayer)) {
                        sourcesSteeringModelLayer[entity.layer] = [];
                    }
                    feature.set('dxfData', entity);
                    if (entity.colorNumber == 256 || !entity.colorNumber) { //sometimes entity has no colorNumber?
                        feature.set('colorNumber', dxf.parsed.tables.layers[entity.layer].colorNumber)
                    } else {
                        feature.set('colorNumber', entity.colorNumber)
                    }
                    sourcesSteeringModelLayer[entity.layer].push(feature);
                }
                i++
            }
        })

        if (Object.keys(sourcesSteeringModelLayer).length < 1) return

        this.layer = new LayerGroup({});

        //groups are layers where key is layer name
        for (const key in sourcesSteeringModelLayer) {
            const features = sourcesSteeringModelLayer[key];
            const dxfLayer = new DXFLayer(this.mapModel, key, childSettings, this, projection, features);
            dxfLayer.drawLayer(drawStyle);
            this.mapElements.push(dxfLayer);
        }

        if (this.parent && this.parent.layer) {
            this.parent.layer.getLayers().push(this.layer);
        }

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }

        if (callback && errorFeatureDrawer) {
            callback(false, invalidEntities);
        }
    }

    clear() {
        if (this.mapElements.length > 0) {
            this.mapElements.forEach(element => {
                element.clear();
            })
        }

        this.layer = null
        this.mapElements = [];
    }

    deselect() {
        this.selectInteraction?.getFeatures().clear();
    }

    select(feature) {
        this.selectInteraction?.getFeatures().push(feature);
    }

    deselectFeatureFromHandle(handle) {
        let featureToRemove = null
        this.selectInteraction?.getFeatures().forEach(selectedFeature => {
            if (selectedFeature.get('dxfData')?.handle == handle)
                featureToRemove = selectedFeature
        });

        if (featureToRemove)
            this.selectInteraction?.getFeatures().remove(featureToRemove)
    }

    toggleCreateMotionplanSelectStyle(state) {
        if (state) {
            if (this.selectInteraction) {
                this.selectInteraction.style_ = (ft, res) => { return FeatureStyle.defaultSelectedStyle(); };

            }
        } else {
            if (this.selectInteraction) {
                switch (this.drawStyle) {
                    case "roadprofiler":
                        this.selectInteraction.style_ = (ft, res) => { return FeatureStyle.customProfilerStyle(ft, res, this.mapModel.dark, true); };
                        break;
                    case "vector":
                        this.selectInteraction.style_ = (ft, res) => { return FeatureStyle.curstomVectorStyle(ft, res, this.mapModel.dark, true); };
                        break;
                    case "spraypoints":
                        this.selectInteraction.style_ = (ft, res) => { return FeatureStyle.customSprayPointsStyle(ft, res, this.mapModel.dark, true); }
                        break;
                    default:
                        this.selectInteraction.style_ = (ft, res) => { return FeatureStyle.customLineStyle(ft, res, this.mapModel.dark, true); };
                        break;
                }
            }
        }
    }
}